<template>
  <div class="evaluate-score-group" v-show="!!show">
    <div class="evaluate-score">
      {{ $t('evaluate_common_total_score') }}：{{ parseInt(score)
      }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'EvaluateScore',
  props: {
    show: {
      type: [Boolean, Number],
      default: true,
    },
    score: {
      type: [String, Number],
      default: 0,
    },
  },
}
</script>

<style lang="scss" scoped>
.evaluate-score-group {
  position: absolute;
  right: 0;
  top: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .evaluate-score {
    height: 45px;
    // background: url(~@/assets/images/score-bg.png) 0 0 no-repeat;
    background-size: 100% 100%;
    color: #ffffff;
    text-align: center;
    line-height: 45px;
    padding: 0 10px 0 35px;
  }
}
</style>
